<template>
   <div class="leads-page">
      <!-- ── Page Header ── -->
      <div class="ms-page-header">
         <div class="ms-page-header__content d-flex justify-content-between align-items-center flex-wrap gap-3 w-100">
            <div class="d-flex align-items-center gap-3">
               <div class="ms-page-header__icon">
                  <i class="fas fa-file-invoice"></i>
               </div>
               <div>
                  <p class="ms-page-header__breadcrumb">Content Library <span class="ms-breadcrumb-sep">/</span> Contract Templates</p>
                  <h1 class="ms-page-header__title">Contract Templates</h1>
               </div>
            </div>
         </div>
      </div>

      <div>
         <ContractTemplates/>
      </div>
   </div>
</template>

<script>
import ContractTemplates from '@/components/ContentLibrary/ContractTemplates/ContractTemplatesDashboard.vue';

export default {
    components: {
       ContractTemplates,
    },
}
</script>

<style scoped>
/* Page Header Styles */
.ms-page-header {
   margin-bottom: 24px;
   padding: 20px 24px;
   background: linear-gradient(135deg, #ffffff 0%, #f4f9fb 100%);
   border: 1px solid rgba(0, 130, 152, 0.15);
   border-left: 5px solid #008298;
   border-radius: 12px;
   box-shadow: 0 4px 18px rgba(0, 78, 90, 0.05);
}

.ms-page-header__content {
   display: flex;
   align-items: center;
   gap: 16px;
}

.ms-page-header__icon {
   width: 44px;
   height: 44px;
   border-radius: 10px;
   background: rgba(0, 130, 152, 0.08);
   display: flex;
   align-items: center;
   justify-content: center;
   font-size: 1.15rem;
   color: #008298;
}

.ms-page-header__title {
   font-size: 1.45rem;
   font-weight: 800;
   color: #00363f;
   margin: 0;
   letter-spacing: -0.3px;
}

.ms-page-header__breadcrumb {
   font-size: 0.76rem;
   color: #557d84;
   font-weight: 700;
   text-transform: uppercase;
   letter-spacing: 0.8px;
   margin-bottom: 4px;
}

.ms-breadcrumb-sep {
   margin: 0 6px;
   color: rgba(0, 130, 152, 0.3);
}
</style>